import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  Inject,
  ChangeDetectorRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { Gallery, GalleryItem, ImageSize, ImageItem } from 'ng-gallery';
import { Lightbox } from 'ng-gallery/lightbox';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { MatSort, Sort } from '@angular/material/sort';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { DeleteModalComponent } from 'src/app/modals/delete-modal/delete-modal.component';
import * as moment from 'moment';
import { DaterangepickerDirective } from 'ngx-daterangepicker-material';
import { RemarkPopupComponent } from 'src/app/modals/remark-popup/remark-popup.component';

export interface Element {
  date: string;
  name: string;
  results: string;
  roles: string;
  states: string;
  conductedBy: string;
  action: boolean;
}

interface sortBy {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-surevey-data',
  templateUrl: './surevey-data.component.html',
  styleUrls: ['./surevey-data.component.scss'],
})
export class SureveyDataComponent implements OnInit {
  form = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  statedata;
  filtershow = true;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  displayedColumns = [
    'date',
    'name',
    'result',
    'roles',
    'states',
    'conductedBy',
    'action',
  ];
  dataSource = new MatTableDataSource<Element>([]);
  avgCount: any = [];
  totalSurvey;
  totalMonthSurvey;

  avgUser: any = [];
  totalUser;
  userdata;
  newDataList = [];
  newData;

  selectedSorting: string;
  selectFilterData1;
  today = new Date();
  customDate = false;
  currentD = this.datePipe.transform(this.today, 'dd/MM/yyyy');
  datepicker = [
    {
      value: '0',
      viewValue: '1 Week',
      startDate: new Date(new Date().setDate(new Date().getDate() - 7)),
      endDate: new Date(),
    },
    {
      value: '1',
      viewValue: '1 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
      endDate: new Date(),
    },
    {
      value: '2',
      viewValue: '3 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 90)),
      endDate: new Date(),
    },
    {
      value: '3',
      viewValue: '6 Months',
      startDate: new Date(new Date().setDate(new Date().getDate() - 180)),
      endDate: new Date(),
    },
    {
      value: '4',
      viewValue: '1 Year',
      startDate: new Date(new Date().setDate(new Date().getDate() - 365)),
      endDate: new Date(),
    },
    { value: '5', viewValue: 'Custom Date' },
  ];
  ranges: any = {
    // 'Today': [moment(), moment()],
    // 'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    '1 Week': [moment().subtract(6, 'days'), moment()],
    '1 Month': [moment().subtract(29, 'days'), moment()],
    '3 Months': [moment().subtract(59, 'days'), moment()],
    '6 Months': [moment().subtract(179, 'days'), moment()],
    '1 Year': [moment().subtract(364, 'days'), moment()],
  };
  filterData = [
    //  { value: '0', viewValue: 'App Version' },
    { value: '1', viewValue: 'State' },
    //{ value: '2', viewValue: 'Language' },
  ];

  selectFilterData;
  searchData;
  filterbyText = '';
  roledata: any;
  filterbystate = '';
  filterbylanguage = '';
  rolebased = [{ role: 'Trader' }, { role: 'Farmer' }];

  stateselect;
  targetstate = [];
  targetstateList: string[] = [
    'Telangana',
    'Tamil Nadu',
    'Kerala',
    'Karnataka',
    'Andhra Pradesh',
  ];
  datarole;
  mostrecent;
  oldRating;
  highestRating;
  lowestRating;

  public matChipArray = [];
  exportcsvdata = false;
  removable = true;
  //sorting table
  dataSourcelist;
  @ViewChild(MatSort) sort: MatSort;
  surveyname: any;
  //dialog: any;
  surveydata;
  surveydatalist: any;
  totalData;
  attachLink: string;
  avgData: any = [];
  SurveyListData;
  SurveyListDataList = [];
  surveyLink: string;
  remark: string;
  surveyDate: string;
  role: string;
  resultLink: string;
  states: string;
  formhide: boolean;
  categorydata: any;
  filterbysurveyName: any;
  SurveyId1;
  submitted: boolean;
  edit: boolean;
  response: any;
  id: any;
  surveyLinkId: any;
  resultLinkId: any;
  statesId: any;
  roleId: any;
  surveyDateId: any;
  fiterbyreportkeylist: any;
  filterbyconductName: any;
  //avgCount:any;
  maxDate;
  minDate;
  @ViewChild(DaterangepickerDirective, { static: false })
  pickerDirective: DaterangepickerDirective;
  Rate: any;
  reg: string | RegExp;
  constructor(
    private router: Router,
    public toastr: ToastrService,
    private fb: FormBuilder,
    public gallery: Gallery,
    private spinner: NgxSpinnerService,
    public lightbox: Lightbox,
    public _userService: UserManagementService,
    private datePipe: DatePipe,
    private ref: ChangeDetectorRef,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group({
      surveyID: ['', [Validators.required]],
      surveyName: ['', [Validators.required]],
      attachLink: ['', [Validators.pattern(this.reg)]],
      resultLink: ['', [Validators.required]],
      role: ['', [Validators.required]],
      surveyDate: ['', [Validators.required]],
      //remark: ['', [Validators.required]],
      states: [],
    });
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    // this._userService.getSurveyList(postdata).subscribe(data => {
    //   this.surveydata = data
    //   this.surveydatalist = this.surveydata.result.data
    // });

    this.getSurveyListData();
    this.GetSurveyData();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  getSurveyListData() {
    this.spinner.show();
    var postdata = {
      name: '',
      roles: '',
      states: '',
      fromDate: '',
      toDate: '',
      search: '',
      pageNumber: 0,
      pageSize: 0,
    };

    this._userService.getSurveyList(postdata).subscribe((data) => {
      this.SurveyListData = data;
      this.paginationProperty = this.SurveyListData.result.data;
      this.length = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.totalPages = this.paginationProperty.totalPages;
      this.dataSource = new MatTableDataSource<Element>(
        this.SurveyListData.result.data.list
      );

      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });
  }

  GetSurveyData() {
    this._userService.getSurveyDataHeader().subscribe((data) => {
      this.totalData = data;
      this.avgData = this.totalData.result.data;
    });
  }

  startdata;
  enddata;
  sharedate;
  onDateRangeChanged(dates) {
    this.sharedate = dates;
    if (dates) {
      this.enddata = dates.endDate
        ? this.datePipe.transform(dates.endDate, 'yyyy/MM/dd HH:mm:ss')
        : null;
      this.startdata = dates.startDate
        ? this.datePipe.transform(dates.startDate, 'yyyy/MM/dd HH:mm:ss')
        : null;
    }
  }

  /*=========================================== apply filter ======================================================================== */
  filterbynamedata = '';
  namedata = '';
  filterbyresultName = '';
  resultName = '';
  filterbyroleName = '';
  roleName = '';
  filterbystateName = '';
  stateName = '';
  filterbyformdate = '';
  formdate = '';
  filterbytodayte = '';
  todayte = '';
  filterbysharedate = '';

  applyFilter(checkEmpty) {
    if (
      checkEmpty &&
      !this.searchData &&
      !this.roleName &&
      !this.stateName &&
      !this.sharedate.endDate &&
      !this.sharedate.startDate
    ) {
      alert('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbyText = this.searchData;
      this.filterbynamedata = this.namedata;
      // this.filterbyresultName= this.resultName;
      this.filterbyroleName = this.roleName;
      this.filterbystateName = this.stateName;
      this.filterbyformdate = this.formdate;
      this.filterbytodayte = this.datePipe.transform(
        this.todayte,
        'yyyy/MM/dd hh:mm:ss'
      );
      let indexnamedata = this.matChipArray.findIndex(
        (x) => x.tag === 'namedata'
      );
      // let indexresultName = this.matChipArray.findIndex(x => x.tag === 'resultName');
      let indexroleName = this.matChipArray.findIndex(
        (x) => x.tag === 'roleName'
      );
      let indexstateName = this.matChipArray.findIndex(
        (x) => x.tag === 'stateName'
      );
      //  let indexsource = this.matChipArray.findIndex(x => x.tag === 'source');
      //  let indexsubProductName = this.matChipArray.findIndex(x => x.tag === 'subProductName');
      let indexformdate = this.matChipArray.findIndex(
        (x) => x.tag === 'formdate'
      );
      let indextodayte = this.matChipArray.findIndex(
        (x) => x.tag === 'todayte'
      );
      let indexsharedate = this.matChipArray.findIndex(
        (x) => x.tag === 'sharedate'
      );
      if (this.namedata != '') {
        if (indexnamedata > -1) {
          this.matChipArray[indexnamedata].name = 'Name' + ':' + this.namedata;
        } else {
          if (this.namedata != '' && this.namedata != undefined) {
            this.matChipArray.push({
              name: 'Name' + ':' + this.namedata,
              tag: 'name',
              flag: true,
            });
          }
        }
      }

      // if (this.resultName != '') {
      //   if (indexresultName > -1) {
      //     this.matChipArray[indexresultName].name = "Result" + ":" + this.resultName;
      //   } else {

      //     if (this.resultName != "" && this.resultName != undefined) {
      //       this.matChipArray.push({ 'name': "Result" + ":" + this.resultName, 'tag': 'resultName', 'flag': true })
      //     }
      //   }
      // }

      if (this.roleName != '') {
        if (indexroleName > -1) {
          this.matChipArray[indexroleName].name = 'Role' + ':' + this.roleName;
        } else {
          if (this.roleName != '' && this.roleName != undefined) {
            this.matChipArray.push({
              name: 'Role' + ':' + this.roleName,
              tag: 'roleName',
              flag: true,
            });
          }
        }
      }

      if (this.stateName != '') {
        if (indexstateName > -1) {
          this.matChipArray[indexstateName].name =
            'State' + ':' + this.stateName;
        } else {
          if (this.stateName != '' && this.stateName != undefined) {
            this.matChipArray.push({
              name: 'State' + ':' + this.stateName,
              tag: 'stateName',
              flag: true,
            });
          }
        }
      }
      // if (this.formdate != '') {
      //   if (indexformdate > -1) {
      //     this.matChipArray[indexformdate].name = "Date Range" + ":" + this.formdate;
      //   } else {

      //     if (this.formdate != "" && this.formdate != undefined) {
      //       this.matChipArray.push({ 'name': "Date Range" + ":" + this.formdate, 'tag': 'formdate', 'flag': true })
      //     }

      //   }
      // }

      // if (this.todayte != '') {
      //   if (indexformdate > -1) {
      //     this.matChipArray[indextodayte].name = "Date Range" + ":" + this.todayte;
      //   } else {

      //     if (this.todayte != "" && this.todayte!= undefined) {
      //       this.matChipArray.push({ 'name': "Date Range" + ":" + this.todayte, 'tag': 'todayte', 'flag': true })
      //     }

      //   }
      // }
      if (this.sharedate && this.startdata && this.enddata) {
        if (indexsharedate > -1) {
          this.matChipArray[indexsharedate].name =
            'Shared date' +
            ':' +
            (this.sharedate['startDate']
              ? this.sharedate['startDate'].format('DD/MM/YYYY')
              : '') +
            ' to ' +
            (this.sharedate['endDate']
              ? this.sharedate['endDate'].format('DD/MM/YYYY')
              : '');
        } else {
          this.matChipArray.push({
            name:
              'Shared date' +
              ':' +
              (this.sharedate['startDate']
                ? this.sharedate['startDate'].format('DD/MM/YYYY')
                : '') +
              ' to ' +
              (this.sharedate['endDate']
                ? this.sharedate['endDate'].format('DD/MM/YYYY')
                : ''),
            tag: 'sharedate',
            flag: true,
          });
        }
      }

      var postdata = {
        fromDate: this.startdata,
        todate: this.enddata,
        search: this.filterbyText,
        name: this.filterbynamedata,
        roles: this.filterbyroleName,
        states: this.filterbystateName,
        pageNumber: 0,
        pageSize: 10,
      };

      this._userService.getSurveyList(postdata).subscribe((data) => {
        this.newData = data;
        this.paginationProperty = this.newData.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.totalPages = this.paginationProperty.totalPages;
        this.dataSource = new MatTableDataSource<Element>(
          this.newData.result.data.list
        );

        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }

  remove(index, tag): void {
    if (tag === 'surveyName') {
      this.matChipArray.splice(index, 1);
      this.surveyname = '';
    }

    if (tag === 'roleName') {
      this.matChipArray.splice(index, 1);
      this.roleName = '';
    }

    if (tag === 'stateName') {
      this.matChipArray.splice(index, 1);
      this.stateName = '';
    }
    if (tag === 'sharedate') {
      this.matChipArray.splice(index, 1);
      this.sharedate = undefined;
      this.startdata = '';
      this.enddata = '';
    }
    // if (tag === 'formdate') {
    //   this.matChipArray.splice(index, 1);
    //   // this.formdate = "";
    //   this.formdate = "";
    //   this.startdata = "";
    //   this.enddata = "";
    //   // this.form.controls.start.value="";
    // }
    // if (tag === 'todayte') {
    //   this.matChipArray.splice(index, 1);
    //   this.todayte = "";
    // }
    this.applyFilter(false);
  }

  selectItem(item) {
    if (item.value == 'Custom Date') {
      this.customDate = true;
    } else {
      this.customDate = false;
    }
  }

  changeFn(event: any) {
    if (event.isTrusted == true) {
      this.applyFilter(false);
    }
  }
  formPage() {
    this.router.navigate(['/survey-conduct']);
  }

  editPage(data1) {
    this.edit = true;
    // this.surveydata = data1
    // this.surveydatalist = this.surveydata.result.data
    this.form.get('surveyID').setValue(data1.surveyId);
    this.form.get('surveyName').setValue(data1.name);
    this.form.get('attachLink').setValue(data1.surveyLink);
    this.form.get('resultLink').setValue(data1.result);
    this.form.get('role').setValue(data1.roles.split(','));
    this.form.get('surveyDate').setValue(data1.date);
    this.form.get('states').setValue(data1.states.split(', '));
  }
  listPage() {
    this.edit = false;
  }

  onSubmit() {
    this.submitted = true;
    let x;
    const ref = this.openRemarkDialog();
    ref.afterClosed().subscribe((data) => {
      x = data;
      if (this.form.valid && x) {
        if (this.form.value.attachLink != '') {
          var pattern = new RegExp(this.reg);
          var result = pattern.test(this.form.value.attachLink);
          if (result == false) {
            alert('Please enter valid surveyLink');
            return false;
          }
        }

        // let newsId = this.form.value.newsId;
        this.spinner.show();
        data = {
          surveyName: this.form.value.surveyName,
          surveyLink: this.form.value.attachLink,
          resultLink: this.form.value.resultLink,
          role: this.form.value.role.join(),
          surveyDate: '',
          remark: x,
          states: this.form.value.states,
          surveyId: this.form.value.surveyID,
        };

        // if (confirm("Are you sure you want to publish this survey updates?")) {
        this._userService.updateSurveyData(data).subscribe((data) => {
          this.response = data;
          // if (confirm("Do you want to send this notification to selected state/s users?")) {

          // this._userService.sentapplicationremaindernotification(formdata).subscribe(data => {
          //   this.response = data;
          // });
          this.spinner.hide();
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
        });
        //  }
        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/survey-data']);
          this.spinner.hide();
        });
      }
      // else {
      //   alert("Please fill all mandatory fields and enter valid values")
      // }
    });
  }

  openRemarkDialog() {
    const dialogRef = this.dialog.open(RemarkPopupComponent, {});
    return dialogRef;
  }
  // onSubmit() {
  //   this.submitted = true
  //   this.spinner.show()
  //   var quantityval: any = 1

  //   this.Rate = this.form.value.Rate;
  //   this.remark = this.form.value.Remark;
  //   this.id = this.form.value.id;

  //   if (this.form.valid) {
  //     this.spinner.show()
  //     let text = confirm("Are you sure you want to publish this survey updates?");
  //     if (text == true) {

  //       var data = {
  //         "surveyName": this.form.value.surveyName,
  //         "attachLink": this.form.value.surveyLink,
  //         "resultLink": this.form.value.resultLink,
  //         "role": this.form.value.role.join(),
  //         "surveyDate":"",
  //         "remark": this.form.value.remark,
  //         "states":this.form.value.states,
  //         "surveyId": this.form.value.surveyID
  //       }

  //       this._userService.updateSurveyData(data).subscribe(data => {
  //         this.response = data;
  //         this.spinner.hide()
  //         this.toastr.success(this.response.result.message, 'Success', {
  //           timeOut: 4000,
  //         });
  //       });
  //       this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
  //         this.router.navigate(['/survey-data']);
  //        // window.location.reload();
  //         this.spinner.hide();

  //       });
  //     } else {
  //       this.spinner.hide()
  //     }
  //   }
  //   else {
  //     this.spinner.hide()
  //     alert("Please enter valid and mandatory field peroperly")
  //   }
  // }

  apidata;
  maindata;
  filename;

  /*......................Pagination.................*/
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex;
  pagechangeevent;
  searchText = '';
  searchDate = '';

  public getServerData(event?: PageEvent) {
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;
    if (this.exportcsvdata == true) {
      var postdata = {
        fromDate: this.startdata,
        todate: this.enddata,
        search: this.filterbyText,
        name: this.filterbynamedata,

        roles: this.filterbyroleName,

        states: this.filterbystateName,

        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService.getSurveyList(postdata).subscribe((data) => {
        this.userdata = data;
        this.newData = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.newData);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    } else {
      postdata = {
        fromDate: '',
        todate: '',
        search: '',
        name: '',

        roles: '',
        states: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
      };

      this._userService.getSurveyList(postdata).subscribe((data) => {
        this.userdata = data;
        this.newData = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.newData);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }

  exportcsv() {
    if (this.exportcsvdata == true) {
      this.applyFilter(false);
      var postdata = {
        name: this.filterbynamedata,
        roles: this.filterbyroleName,
        states: this.filterbystateName,
        fromDate: this.filterbyformdate,
        toDate: this.filterbytodayte,
        result: this.filterbyresultName,
        search: this.filterbyText,

        // "reportKeyList":this.fiterbyreportkeylist
      };

      this._userService.getSurveyReports(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Surveylist.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
      });
    } else {
      var postdata = {
        name: this.filterbynamedata,
        roles: this.filterbyroleName,
        states: this.filterbystateName,
        fromDate: this.filterbyformdate,
        toDate: this.filterbytodayte,
        result: this.filterbyresultName,
        search: this.filterbyText,

        // "reportKeyList":this.fiterbyreportkeylist
      };
      this._userService.getSurveyReports(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Surveylist.xlsx';
        anchor.href = url;
        anchor.click();
      });
    }
  }
  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }

  openDialog(data2): void {
    this.spinner.show();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);

    const dialogRef = this.dialog.open(SureveyDeletePopup, {
      // width: '30%',
      // height: '27%',
      data: { id: data2.surveyId },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.applyFilter(false);
      this.GetSurveyData();
    });
  }

  dialogresult;
  mainresult;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(SureveyExportData, {
      width: '60%',
      height: '53%',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);
          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyFilter(false);
              if (this.customDate == true) {
                var postdata = {
                  fromDate: this.startdata,
                  toDate: this.enddata,
                  search: this.filterbyText,
                  name: this.filterbynamedata,
                  role: this.filterbyroleName,
                  states: this.filterbystateName,
                  result: this.filterbyresultName,

                  reportkeyList: Result,

                  // "reportKeyList":this.fiterbyreportkeylist
                };
              } else {
                postdata = {
                  fromDate: this.startdata,
                  toDate: this.enddata,
                  search: this.filterbyText,
                  name: this.filterbynamedata,
                  role: this.filterbyroleName,
                  states: this.filterbystateName,
                  result: this.filterbyresultName,

                  reportkeyList: Result,
                };
              }

              this._userService.getSurveyReports(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                var anchor = document.createElement('a');
                anchor.download = 'PKF_SurveyData';
                anchor.href = url;
                anchor.click();
              });
            } else {
              postdata = {
                fromDate: '',
                toDate: '',
                search: '',
                name: '',
                role: '',
                states: '',
                result: '',

                reportkeyList: Result,
              };
              this._userService.getSurveyReports(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                // window.open(url);
                var anchor = document.createElement('a');
                anchor.download = 'PKF_PKF_SurveyData.xlsx';
                anchor.href = url;
                anchor.click();
              });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport();
        }
      }
    });
  }
}

@Component({
  selector: 'surevey-delete-popup',
  templateUrl: 'surevey-delete-popup.html',
})
export class SureveyDeletePopup {
  formdelet: FormGroup;
  response;
  constructor(
    public dialogRef: MatDialogRef<SureveyDeletePopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.formdelet = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }

  onSubmit() {
    if (this.formdelet.valid) {
      var postdata = {
        surveyId: this.data.id,
        remark: this.formdelet.value.Remark,
      };
      this._userService.removeSurveydata(postdata).subscribe((data) => {
        this.response = data;
        //window.location.reload();
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        this.dialogRef.close();
      });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
  }
}

//

/* ===========================================delet-pop-up==============================================================*/

/* ===========================================Export-function ==============================================================*/

@Component({
  selector: 'surevey-export-data',
  templateUrl: 'surevey-export-data.html',
})
export class SureveyExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<SureveyExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'Name', value: 'Name', isSelected: false },
      { id: 2, viewValue: 'Results', value: 'Result', isSelected: false },
      { id: 3, viewValue: 'Role', value: 'Role', isSelected: false },
      { id: 4, viewValue: 'States', value: 'States', isSelected: false },
      { id: 5, viewValue: 'Date', value: 'Date', isSelected: false },
      {
        id: 6,
        viewValue: 'Conducted By',
        value: 'ConductedBy',
        isSelected: false,
      },
    ];
    this.getCheckedItemList();
  }
  //  onNoClick(): void {
  //   // this.dialogRef.close();
  //  }
  ngOnInit(): void {
    // this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
